// extracted by mini-css-extract-plugin
export var color = "colorPicker-module--color--7U3yO";